document.addEventListener("DOMContentLoaded", function () {
  const swiperEl = document.querySelector(".testimonial-grid-containor");

  if (swiperEl) {
    new Swiper(swiperEl, {
      loop: false,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 36,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 1
        },
        1025: {
          slidesPerView: 3,
          slidesPerGroup: 1
        }
      }
    });
  }
});